import React, { createContext, useEffect, useState, useCallback, useRef } from 'react';
import io from 'socket.io-client';
import config from "config/config";
import { retriveAccessToken } from "storage/cookieStorage";

export const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const socketRef = useRef(null);

  const connectSocket = useCallback(() => {
    if (socketRef.current) {
      return;
    }

    const token = retriveAccessToken();
    const newSocket = io(config.socketGateway.SOCKET_BASE_URL, {
      extraHeaders: { authorization: token },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
    });

    newSocket?.on('connect', () => {
      console.log('Connected to socket');
    });

    newSocket?.on('disconnect', () => {
      console.log('Socket disconnected, waiting for socket.io to reconnect...');
    });

    newSocket?.on('connect_error', (err) => {
      console.log('Connection Error:', err.message);
    });

    socketRef.current = newSocket;
    setSocket(newSocket);
  }, []);

  useEffect(() => {
    connectSocket();

    return () => {
      const currentSocket = socketRef.current;
      socketRef.current = null;

      if (currentSocket) {
        currentSocket.disconnect();
      }
    };
  }, [connectSocket]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};
